import CardSort from "assets/animations/cardSort.json";
import Carousel from "assets/animations/carousel.json";
import FlipCard from "assets/animations/Flip_cards.json";
import Hotspots from "assets/animations/hotspots.json";
import ImageText from "assets/animations/image_and_text.json";

export const sections = {
  0: "Induction",
  1: "Welcome",
  2: "Take a look around",
  3: "Drugs & Alcohol",
  4: "Exclusion zones",
  5: "Speed limits",
  6: "Scaffold",
  7: "Falls",
  8: "Dust",
  9: "Card System",
  10: "Site Rules",
  11: "Induction Complete",
};

export const assesment = {
  3: "Drugs & Alcohol",
  4: "Exclusion zones",
  5: "Speed limits",
  8: "Falls",
  6: "Scaffold",
  7: "Dust",
};

export const statusIndicator = [
  // {
  //   color: "#DDDDDD",
  //   name: "Not completed",
  // },
  {
    color: "#BB6BD9",
    name: "Pending",
    type: "pending_induction",
  },
  {
    color: "#03CE91",
    name: "Successful",
    type: "permitted",
  },
  {
    color: "#F2C75E",
    name: "Renewal required",
    type: "renewal_required",
  },

  {
    color: "#E26C82",
    name: "Diqualified",
    type: "not_permitted",
  },
];

export const completeStatusEnums = {
  pending_induction: "Pending",
  permitted: "Completed",
  renewal_required: "Renewal Required",
  renewal_required_soon: "Renewal Required Soon",
};

export const chapterAnimations = {
  CardSort: CardSort,
  "Carousel Block": CardSort,
  FlipCards: FlipCard,
  Hotspots: Hotspots,
  ImageAndText: ImageText,
};

export const tableIndicator = [
  {
    color: "#BB6BD9",
    name: "Pending",
    type: "pending_induction",
  },
  {
    color: "#03CE91",
    name: "Safe",
    type: "permitted",
  },
  {
    color: "#F2C75E",
    name: "Renewal required",
    type: "renewal_required",
  },

  {
    color: "#E26C82",
    name: "Diqualified",
    type: "not_permitted",
  },
];
